import i18n from "src/i18n";

import { TimelineEvent } from "@customTypes/timeline";


export const getLabelForRecordType = (
  category: TimelineEvent["recordType"]
) => {
  switch (category) {
    case "consultation":
      return i18n.t("with") + " ";

    case "laboratory":
    case "radiology":
      return i18n.t("ordered-by");

    case "prescription":
    case "treatment":
      return i18n.t("prescribed-by");

    case "immunization":
      return i18n.t("administered-by");

    case "footnote":
      return i18n.t("written-by");

    default:
      break;
  }
};
